import { ref, onMounted } from 'vue'

const isCollapsed = ref(false)
let initialized = false

export function useAppLayout() {
  // Load sidebar state from localStorage on first use
  if (!initialized) {
    initialized = true
    onMounted(() => {
      try {
        const saved = localStorage.getItem('sidebarCollapsed')
        if (saved !== null) {
          isCollapsed.value = JSON.parse(saved)
        }
      } catch (error) {
        console.error('Failed to load sidebar state:', error)
      }
    })
  }

  const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value
    // Persist the new state to localStorage
    try {
      localStorage.setItem('sidebarCollapsed', JSON.stringify(isCollapsed.value))
    } catch (error) {
      console.error('Failed to save sidebar state:', error)
    }
  }

  return {
    isCollapsed,
    toggleSidebar
  }
}
